export enum DOCUMENT_LIBRARY_PARAM_KEYS {
	SELECTED_TREE_ITEM = 'selectedTreeItem',
	EXPANDED_TREE_IDS = 'expandedTreeIds',
}
